import React from "react";

import "./PerformanceInfoOverlay.css";
import { getPerformanceOverlayLayout } from "./PerformanceInfoOverlayLayout";

export interface PerformanceInfoOverlayItem {
  label: string;
  value: string | number | null | undefined;
  unit?: string;
}

interface PerformanceInfoOverlayProps {
  topItems?: PerformanceInfoOverlayItem[];
  bottomItems?: PerformanceInfoOverlayItem[];
  className?: string;
  containerWidth?: number;
  containerHeight?: number;
}

const renderValue = (item: PerformanceInfoOverlayItem) => {
  if (item.value === null || item.value === undefined || item.value === "") {
    return "-";
  }

  return `${item.value}${item.unit ? ` ${item.unit}` : ""}`;
};

const PerformanceInfoOverlay = ({
  topItems = [],
  bottomItems = [],
  className = "",
  containerWidth = 500,
  containerHeight = 700,
}: PerformanceInfoOverlayProps) => {
  if (topItems.length === 0 && bottomItems.length === 0) {
    return null;
  }

  const { topPanelStyle, bottomPanelStyle } = getPerformanceOverlayLayout(
    containerWidth,
    containerHeight
  );

  return (
    <div className={`performance-info-overlay ${className}`.trim()}>
      {topItems.length > 0 && (
        <div
          className="performance-info-overlay__panel performance-info-overlay__panel--top"
          style={topPanelStyle}
        >
          {topItems.map((item) => (
            <React.Fragment key={item.label}>
              <span className="performance-info-overlay__label">{item.label}:</span>
              <span className="performance-info-overlay__value">{renderValue(item)}</span>
            </React.Fragment>
          ))}
        </div>
      )}

      {bottomItems.length > 0 && (
        <div
          className="performance-info-overlay__panel performance-info-overlay__panel--bottom"
          style={bottomPanelStyle}
        >
          {bottomItems.map((item) => (
            <React.Fragment key={item.label}>
              <span className="performance-info-overlay__label">{item.label}:</span>
              <span className="performance-info-overlay__value">{renderValue(item)}</span>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default PerformanceInfoOverlay;
